import type { Router } from 'vue-router'
import { usePermissionStoreWithOut } from '@/store-pinia/modules/permission'
import { useTagsViewStoreWithOut } from '@/store-pinia/modules/tagsView'
import { useBaseStoreWithOut } from '@/store-pinia/modules/base'
import { useUserStoreWithOut } from '@/store-pinia/modules/user'
import { removeRouteChangeListener } from '../routeChange'
import { PageEnum } from '@/enums/pageEnum'

/**
 * 创建登陆注销store状态守护
 * @param router
 */
export function createLogoutGuard(router: Router) {
  const tagsViewStore = useTagsViewStoreWithOut()
  const baseStore = useBaseStoreWithOut()
  const userStore = useUserStoreWithOut()
  const permissionStore = usePermissionStoreWithOut()

  router.afterEach(async (to) => {
    if (to.path === PageEnum.BASE_LOGIN) {
      baseStore.resetState()
      permissionStore.resetState()
      tagsViewStore.resetState()
      userStore.resetState()
      removeRouteChangeListener()
    }
  })
}
